/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Show_MilestonesInputs */

const en_tl_show_milestones = /** @type {(inputs: Tl_Show_MilestonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan by milestone`)
};

const de_tl_show_milestones = /** @type {(inputs: Tl_Show_MilestonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Meilenstein planen`)
};

/**
* | output |
* | --- |
* | "Plan by milestone" |
*
* @param {Tl_Show_MilestonesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_show_milestones = /** @type {((inputs?: Tl_Show_MilestonesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Show_MilestonesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_show_milestones(inputs)
	return en_tl_show_milestones(inputs)
});